import VideoYoutubePlayer from './VideoYoutubePlayer';

export default VideoYoutubePlayer;
